import { DialogConfig } from '@angular/cdk/dialog';
import { AfterViewInit, Directive, effect, inject, linkedSignal, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from 'app/layout/layout.service';

@Directive()
export abstract class MsAbstractBaseDialog implements OnDestroy, OnInit, AfterViewInit {
    config: DialogConfig;
    isMobile = linkedSignal(() => this.layoutService.mobileModeForDialog());
    isFullScreen = signal(false);
    data: any;
    layoutService = inject(LayoutService);
    dialogRef: MatDialogRef<any>;
    fullScreenOnMobile = signal(true);
    constructor() {
        this.data = inject(MAT_DIALOG_DATA);
        this.dialogRef = inject(MatDialogRef);
        console.log('DIALOG-DATA', this.data);
        console.log('DIALOG_ID', this.data?.DIALOG_ID, this.dialogRef.id);
        this.config = this.dialogRef._containerInstance._config;
        if (!this.dialogRef._containerInstance._config.disableClose) {
            this.dialogRef.keydownEvents().subscribe(event => {
                if (event.key == 'Escape') {
                    this.data.cancel = true;
                    this.close();
                }
            });
        }
        effect(() => {
            if (this.isMobile()) {
                if (this.fullScreenOnMobile()) {
                    console.log('mobile');
                    this.isFullScreen.set(true);
                    this.dialogRef.updateSize('100%', '100%');
                    this.dialogRef.addPanelClass('dialog-mobile');
                }
            } else {
                this.isFullScreen.set(false);
                console.log('web');
                this.dialogRef.removePanelClass('dialog-mobile');
                if (this.config) {
                    if (this.config.height) {
                        this.dialogRef.updateSize(this.config.width, this.config.height);
                    } else {
                        this.dialogRef.updateSize(this.config.width);
                    }
                } else {
                    this.dialogRef.updateSize('700px');
                    this.dialogRef._containerInstance._config.minWidth = '700px';
                }
            }
        });
    }

    close(action?: any) {
        if (this.dialogRef) {
            this.dialogRef.close(action);
        }
    }

    ngOnInit() {}

    ngAfterViewInit() {
        setTimeout(() => {
            const browserHeight = window.innerHeight;
            if (this.isMobile() && this.fullScreenOnMobile() && browserHeight < 700) {
                console.log('full size');
                this.dialogRef.updateSize(this.config.width, '100%');
            }
        });
    }

    ngOnDestroy() {
        console.log('dialog closed');
        if (this.dialogRef) {
            delete this.dialogRef;
        }
    }
}
